module.exports = __webpack_public_path__ + "static/altana-daleko-7c9d4d67c54c7bf0390e376da133ba0f.jpg";